import { FC } from 'react';
import * as Accordion from '@radix-ui/react-accordion';

import { CategoriesData } from '../types';
import { capitalize } from '../helpers/capitalize-string';
import { renderCovidTestListItemMobile } from './render';
import { ImageUrl } from '../constants/image-urls';
import { covidSubCategoryId, spermAnalysisSubCategory } from '../constants/tests';
import { sortTestsByNumber } from '../helpers/sort-tests-by-number';

interface SubCategoryAccordionProps {
  category: CategoriesData;
  isSearching: boolean;
  subCategoriesMap: { [key: string]: boolean };
  testsMap: { [key: string]: boolean };
  initialSubCategoryId: string | null;
}

export const SubCategoryAccordion: FC<SubCategoryAccordionProps> = (
  {
    category,
    isSearching,
    subCategoriesMap,
    testsMap,
    initialSubCategoryId
  }): JSX.Element => {
  
  return (
    <Accordion.Root
      type={'multiple'}
      defaultValue={[`${category.id}-${initialSubCategoryId || ''}-accordion`]}
    >
      {category.subCategories.map((subCategory, index) => (
        (!isSearching || subCategoriesMap[subCategory.id]) && (
          <Accordion.Item
            key={`${category.id}-${subCategory.id}-accordion`}
            value={`${category.id}-${subCategory.id}-accordion`}
            className=""
          >
            <div>
              {subCategory.tests.length > 0 && (
                <Accordion.Trigger
                  id={`cb-${subCategory.id}`}
                  className={`w-full active:scale-95 scale-100 transition-all transform duration-300 ease-in-out group genica_acc mt-2`}>
                  <div className="divider-box bg-slate-100 hover:bg-rose-100 px-2 py-2 rounded-lg flex justify-between">
                    <div className="flex items-center w-full">
                      <div className="section-subtitle-line ml-1"></div>
                      <h4 id={'sub-category-title'}
                          className="title section-subtitle left-align sub-category-title">
                        {capitalize(subCategory.name)}
                      </h4>
                    </div>
                    <img className="group-active:rotate-180 mr-3" width={16} height={16} src={ImageUrl.DROPDOWN_ARROW}/>
                  </div>
                </Accordion.Trigger>
              )}
              
              <Accordion.Content
                className="genica_acc_content">
                <div className={`tests-box ${category.subCategories.length > 1 ? 'mb-5' : 'mt-0'} `}>
                  {/*{subCategory.id === covidSubCategoryId && (*/}
                  {/*  <div*/}
                  {/*    className={`px-8 grid ${subCategory.tests[0] && subCategory.tests[0].airportCovidTest && 'grid-cols-4'} ${subCategory.tests[0] && !subCategory.tests[0].mobileLabCovidTest && !subCategory.tests[0].airportCovidTest ? 'grid-cols-4' : ''} `}>*/}
                  {/*    <h2 className="title h3-size covid-table-titles tableHeader flex w-full ">Вид тест</h2>*/}
                  {/*    {subCategory.tests[0] && !subCategory.tests[0].mobileLabCovidTest && !subCategory.tests[0].airportCovidTest && (*/}
                  {/*      <>*/}
                  {/*        <h2 className="title h3-size covid-table-titles text-left tableHeader">Време за*/}
                  {/*          резултат</h2>*/}
                  {/*        /!*<h2 className="title h3-size covid-table-titles tableHeader">Вземане на проба</h2>*!/*/}
                  {/*        /!*<h2 className="title h3-size covid-table-titles tableHeader">Интервал на услугата</h2>*!/*/}
                  {/*        <h2 id="w-node-d0bddac2-4893-e608-6824-3fc256be4fb0-634ceff9"*/}
                  {/*            className="title h3-size covid-table-titles tableHeader">Тип проба</h2>*/}
                  {/*      </>*/}
                  {/*    )}*/}
                  {/*    */}
                  {/*    {subCategory.tests[0] && subCategory.tests[0].airportCovidTest && (*/}
                  {/*      <>*/}
                  {/*        <h2 className="title h3-size covid-table-titles text-left tableHeader">Време за*/}
                  {/*          резултат</h2>*/}
                  {/*        /!*<h2 className="title h3-size covid-table-titles tableHeader">Вземане на проба</h2>*!/*/}
                  {/*        /!*<h2 className="title h3-size covid-table-titles tableHeader">Интервал на услугата</h2>*!/*/}
                  {/*        <h2 id="w-node-d0bddac2-4893-e608-6824-3fc256be4fb0-634ceff9"*/}
                  {/*            className="title h3-size covid-table-titles tableHeader">Тип проба</h2>*/}
                  {/*      </>*/}
                  {/*    )}*/}
                  {/*    <h2 id="w-node-d0bddac2-4893-e608-6824-3fc256be4fb0-634ceff9"*/}
                  {/*        className="text-right title h3-size covid-table-titles tableHeader flex w-full justify-end">Цена</h2>*/}
                  {/*  </div>*/}
                  {/*)}*/}
                  
                  {/*{subCategory.id === covidSubCategoryId && (*/}
                  {/*  renderCovidTestListItem(arrangeCovid(subCategory.tests))*/}
                  {/*)}*/}
                  
                  
                  {subCategory.id === covidSubCategoryId && sortTestsByNumber(subCategory.tests).map((test, testIndex) => {
                    return (
                      (!isSearching || testsMap[test.id]) && (
                        <a href={`/test/${test.slug}`} key={testIndex}
                           data-w-id="eabe16cf-6688-4182-9962-4a07cd774e31"
                           className="test-link desktop w-full">
                          <div className={`row-background ${testIndex % 2 === 0 ? '' : 'bg-gray'}`}>
                            <div className="w-layout-grid table-row-grid  all two-columns">
                              <div id="w-node-eabe16cf-6688-4182-9962-4a07cd774e34-634ceff9"
                                   className="table-row-content">
                                <div className="name text-left">
                                  {test.name}
                                </div>
                              </div>
                              
                              <div id="w-node-eabe16cf-6688-4182-9962-4a07cd774e3a-634ceff9"
                                   className="table-row-content price">
                                <div className="price">
                                  {(test.price?.length || test.price) && (
                                    <span>{test.price?.replace('лева', '').trim()} лв.</span>
                                  )}
                                  
                                  {/*// @ts-ignore*/}
                                  {test.price.length === 0 && (
                                    <span>-</span>
                                  )}
                                
                                </div>
                              </div>
                              
                              <div className="info-icon">
                                <img style={{ display: 'block', opacity: 1 }}
                                     loading="lazy"
                                     src={ImageUrl.INFO_ICON} alt=""
                                     className="normal"/><img
                                style={{ opacity: 0, display: 'none' }} loading="lazy"
                                src={ImageUrl.INFO_ICON_HOVER}
                                alt="" className="hover"/></div>
                            </div>
                          </div>
                        </a>
                      )
                    );
                  })}
  
                  {subCategory.id === spermAnalysisSubCategory && sortTestsByNumber(subCategory.tests).map((test, testIndex) => {
                    return (
                      (!isSearching || testsMap[test.id]) && (
                        <a href={`/test/${test.slug}`} key={testIndex}
                           data-w-id="eabe16cf-6688-4182-9962-4a07cd774e31"
                           className="test-link desktop w-full">
                          <div className={`row-background ${testIndex % 2 === 0 ? '' : 'bg-gray'}`}>
                            <div className="w-layout-grid table-row-grid  all two-columns">
                              <div id="w-node-eabe16cf-6688-4182-9962-4a07cd774e34-634ceff9"
                                   className="table-row-content">
                                <div className="name text-left">
                                  {test.name}
                                </div>
                              </div>
              
                              <div id="w-node-eabe16cf-6688-4182-9962-4a07cd774e3a-634ceff9"
                                   className="table-row-content price">
                                <div className="price">
                                  {(test.price?.length || test.price) && (
                                    <span>{test.price?.replace('лева', '').trim()} лв.</span>
                                  )}
                  
                                  {/*// @ts-ignore*/}
                                  {test.price.length === 0 && (
                                    <span>-</span>
                                  )}
                
                                </div>
                              </div>
              
                              <div className="info-icon">
                                <img style={{ display: 'block', opacity: 1 }}
                                     loading="lazy"
                                     src={ImageUrl.INFO_ICON} alt=""
                                     className="normal"/><img
                                style={{ opacity: 0, display: 'none' }} loading="lazy"
                                src={ImageUrl.INFO_ICON_HOVER}
                                alt="" className="hover"/></div>
                            </div>
                          </div>
                        </a>
                      )
                    );
                  })}
  
                  {(subCategory.id !== covidSubCategoryId && subCategory.id !== spermAnalysisSubCategory) && subCategory.tests.map((test, testIndex) => {
                    return (
                      (!isSearching || testsMap[test.id]) && (
                        <a href={`/test/${test.slug}`} key={testIndex}
                           data-w-id="eabe16cf-6688-4182-9962-4a07cd774e31"
                           className="test-link desktop w-full">
                          <div className={`row-background ${testIndex % 2 === 0 ? '' : 'bg-gray'}`}>
                            <div className="w-layout-grid table-row-grid  all two-columns">
                              <div id="w-node-eabe16cf-6688-4182-9962-4a07cd774e34-634ceff9"
                                   className="table-row-content">
                                <div className="name text-left">
                                  {test.name}
                                </div>
                              </div>
              
                              <div id="w-node-eabe16cf-6688-4182-9962-4a07cd774e3a-634ceff9"
                                   className="table-row-content price">
                                <div className="price">
                                  {(test.price?.length || test.price) && (
                                    <span>{test.price?.replace('лева', '').trim()} лв.</span>
                                  )}
                  
                                  {/*// @ts-ignore*/}
                                  {test.price.length === 0 && (
                                    <span>-</span>
                                  )}
                
                                </div>
                              </div>
              
                              <div className="info-icon">
                                <img style={{ display: 'block', opacity: 1 }}
                                     loading="lazy"
                                     src={ImageUrl.INFO_ICON} alt=""
                                     className="normal"/><img
                                style={{ opacity: 0, display: 'none' }} loading="lazy"
                                src={ImageUrl.INFO_ICON_HOVER}
                                alt="" className="hover"/></div>
                            </div>
                          </div>
                        </a>
                      )
                    );
                  })}
                </div>
                
                <div className="tests-cards-grid">
                  {subCategory.id === covidSubCategoryId && (
                    renderCovidTestListItemMobile(sortTestsByNumber(subCategory.tests))
                  )}
                  
                  {subCategory.id === spermAnalysisSubCategory && sortTestsByNumber(subCategory.tests).map((test, testIndex) => (
                    (!isSearching || testsMap[test.id]) && subCategory.id !== covidSubCategoryId && (
                      <a
                        href={`/test/${test.slug}`} key={testIndex}
                        data-w-id="6cf0a404-3286-5840-aeaf-25e81d8c0532"
                        className={`test-link-card price w-block bg-black ${testIndex === subCategory.tests.length ? 'bg-black' : '' }`}>
                        <div className="test-card-content-top">
                          <h3 className="title test-title text-left">
                            {test.name}
                          </h3>
                          <div className="info-icon"><img
                            // style="display:block;opacity:1"
                            loading="lazy"
                            src={ImageUrl.INFO_ICON}
                            alt=""
                            className="normal"/><img
                            // style="opacity:0;display:none"
                            loading="lazy"
                            src={ImageUrl.INFO_ICON_HOVER}
                            alt="" className="hover"/></div>
                        </div>
                        
                        <div className="test-details">
                          {/*<div className="test-card-tag smaller-margin">*/}
                          {/*  <div className="card-image-box h-5">*/}
                          {/*    <img src={ImageUrl.CLOCK_ICON} alt=""*/}
                          {/*         className="image"/></div>*/}
                          {/*  <div className="duration-number">*/}
                          {/*    {test.duration && test.duration >= 1 ? `${test.duration} работни дни` : '1 работен ден'}*/}
                          {/*  </div>*/}
                          {/*</div>*/}
                          <div className="test-price-tag ">
                            <div className="card-image-box h-5">
                              <img width="16" src={ImageUrl.PRICE_ICON} alt=""
                                   className="image"/>
                            </div>
                            <div className="price-number">
                              {(test.price?.length || test.price) && (
                                <span>{test.price?.replace('лева', '').trim()} лв.</span>
                              )}
                              {/*// @ts-ignore*/}
                              {test.price.length === 0 && (
                                <span>-</span>
                              )}
                            </div>
                          </div>
                          {/*{test.sample && (*/}
                          {/*  <div className="test-sample-tag">*/}
                          {/*    <div className="card-image-box h-5">*/}
                          {/*      <img src={ImageUrl.SAMPLE_ICON_EMPTY} alt=""*/}
                          {/*           className="image"/>*/}
                          {/*    </div>*/}
                          {/*    <div className="sample">*/}
                          {/*      {test.sample}*/}
                          {/*    </div>*/}
                          {/*  </div>*/}
                          {/*)}*/}
                        </div>
                      
                      </a>
                    )
                  ))}
  
                  {subCategory.id !== spermAnalysisSubCategory && subCategory.tests.map((test, testIndex) => (
                    (!isSearching || testsMap[test.id]) && subCategory.id !== covidSubCategoryId && (
                      <a
                        href={`/test/${test.slug}`} key={testIndex}
                        data-w-id="6cf0a404-3286-5840-aeaf-25e81d8c0532"
                        className={`test-link-card price w-block ${testIndex === subCategory.tests.length - 1 ? '' : '' }`}>
                        <div className="test-card-content-top">
                          <h3 className="title test-title text-left">
                            {test.name}
                          </h3>
                          <div className="info-icon"><img
                            // style="display:block;opacity:1"
                            loading="lazy"
                            src={ImageUrl.INFO_ICON}
                            alt=""
                            className="normal"/><img
                            // style="opacity:0;display:none"
                            loading="lazy"
                            src={ImageUrl.INFO_ICON_HOVER}
                            alt="" className="hover"/></div>
                        </div>
        
                        <div className="test-details">
                          {/*<div className="test-card-tag smaller-margin">*/}
                          {/*  <div className="card-image-box h-5">*/}
                          {/*    <img src={ImageUrl.CLOCK_ICON} alt=""*/}
                          {/*         className="image"/></div>*/}
                          {/*  <div className="duration-number">*/}
                          {/*    {test.duration && test.duration >= 1 ? `${test.duration} работни дни` : '1 работен ден'}*/}
                          {/*  </div>*/}
                          {/*</div>*/}
                          <div className="test-price-tag ">
                            <div className="card-image-box h-5">
                              <img width="16" src={ImageUrl.PRICE_ICON} alt=""
                                   className="image"/>
                            </div>
                            <div className="price-number">
                              {(test.price?.length || test.price) && (
                                <span>{test.price?.replace('лева', '').trim()} лв.</span>
                              )}
                              {/*// @ts-ignore*/}
                              {test.price.length === 0 && (
                                <span>-</span>
                              )}
                            </div>
                          </div>
                          {/*{test.sample && (*/}
                          {/*  <div className="test-sample-tag">*/}
                          {/*    <div className="card-image-box h-5">*/}
                          {/*      <img src={ImageUrl.SAMPLE_ICON_EMPTY} alt=""*/}
                          {/*           className="image"/>*/}
                          {/*    </div>*/}
                          {/*    <div className="sample">*/}
                          {/*      {test.sample}*/}
                          {/*    </div>*/}
                          {/*  </div>*/}
                          {/*)}*/}
                        </div>
      
                      </a>
                    )
                  ))}
                </div>
              </Accordion.Content>
            </div>
          </Accordion.Item>
        )))}
    </Accordion.Root>
  );
};
